import React, { useEffect, useState } from 'react';
import * as d3 from 'd3';
import cloud from 'd3-cloud';
import Spinner from 'react-bootstrap/Spinner';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import RunBoostChart from './RunBoostChart';

import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';

const PlaylistsDropdownPlayer = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [tracks, setTracks] = useState([]);

  const handleDropdownSelect = async (item) => {
    setSelectedItem(item);
    try {
      const response = await fetch(`/playlistx?list_id=${item}`);
      if (response.ok) {
        const data = await response.json();
        setTracks(data);
      }
    } catch (error) {
      console.error("Error fetching tracks:", error);
    }
  };
  const getIframeSrc = () => {
    var url = 'https://open.spotify.com/embed/playlist/' + selectedItem + '?utm_source=generator'
    if (selectedItem == null) url = "";
    return url;
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/playlistsx');
        if (response.status === 401) {
          // Redirect the user to the login page or display an error message
          window.location.href = '/';
          return;
        }
        if (response.status === 500) {
          // Redirect the user to the login page or display an error message
          alert("Server error");
          window.location.href = '/';
          return;
        }
        const jsonData = await response.json();
        setData(jsonData);
        setLoading(false);
      } catch (error) {
        console.error(error);
        // Handle other errors here
        alert("error retrieving data");
        window.location.href = '/';
        return;
      }
    };

    fetchData();
  }, []);


  return (

    <div className="container">

      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div>
          <DropdownButton id="dropdown-basic-button" drop="down-centered" title="Load One of your playlists" onSelect={handleDropdownSelect}>
            {data.map((d, i) => (
              <Dropdown.Item eventKey={d.id}
                style={{ fontSize: '36px', padding: '10px 20px' }}
              > {d.name}



                ({d.numberOfTracks})
              </Dropdown.Item>



            ))}
          </DropdownButton>

          {tracks.length > 0 && <RunBoostChart data={tracks} />}

          <br />
          <iframe
            style={{ borderRadius: '12px' }} // Use double curly braces for inline styles
            src={getIframeSrc()}
            width='100%'
            height='852'
            frameBorder='0'
            allowFullScreen=''
            allow='autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture'
            title="playlist"
            loading='lazy'>
          </iframe>



        </div>

      )}
    </div>
  );
};

export default PlaylistsDropdownPlayer;
